var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"plus-icon",attrs:{"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M7 2.5v9M2.5 7h9"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }